export default __webpack_public_path__ + "assets/b7396cf0f8b5867ea7061e40d436948a.png";